import React from 'react';

export function PersonIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 48 48"
      {...props}
    >
      <path d="M24 12c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4 1.8-4 4-4zm0 20c5.4 0 11.6 2.58 12 4H12c.46-1.44 6.62-4 12-4zm0-24c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 20c-5.34 0-16 2.68-16 8v4h32v-4c0-5.32-10.66-8-16-8z" />
    </svg>
  );
}
